import { ErrorMessages } from '../types';

export const defaultErrorMessages: ErrorMessages = {
	default: 'Le format de l’adresse email n’est pas valide.'
};
